import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Components/Navbar'
import Footer from '../Pages/Shared/Footer'
import FooterMirai from '../Pages/Shared/FooterMirai'

const Main = () => {
  return (
    <div className='h-screen'>
      <Navbar></Navbar>
      <Outlet></Outlet>
      <FooterMirai></FooterMirai>
    </div>
  )
}

export default Main
